module.exports = __webpack_public_path__ + "img/family.34cf6c9.svg";